import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { VendorFilters, VendorSlice } from "./vendorsTypes.ts";

const initialState: VendorSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const vendorsSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<VendorSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<VendorSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof VendorFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<VendorSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  vendorsSlice.actions;

export const selectPage = (state: RootState) => state.vendors.page;
export const selectRowsPerPage = (state: RootState) =>
  state.vendors.rowsPerPage;
export const selectFilter = (state: RootState) => state.vendors.filter;
export const selectSort = (state: RootState) => state.vendors.sort;

export default vendorsSlice.reducer;
